import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { environment } from '@unico-people/shared/utils/environments';

@Component({
  selector: 'up-ui-companies-sidebar',
  templateUrl: './ui-companies-sidebar.component.html',
  styleUrls: ['./ui-companies-sidebar.component.scss']
})
export class UiCompaniesSidebarComponent {
  @Input() companies: any;
  @Input() acc: string;
  @Output() change = new EventEmitter<any>();
  url: string = environment.cdn_url;

  trackByItems(index: number, company: any): number { return index; }
}
